import get from 'transmute/get';
export const getThreadRemovalAudit = get('audit');
export const getThreadRemovalChanges = get('changes');
export const getThreadRemovalType = get('@type');